import { EmailLevel } from '@xver/@types/user';
import { useTranslation } from 'react-i18next';

interface EmailVerificationBadgeProps {
    level: string;
}

export default function EmailVerificationBadge({ level }: EmailVerificationBadgeProps) {
    const { t } = useTranslation('profile');
    const verified = level === EmailLevel.E2;

    return (
        <span
            className={`inline-flex items-center px-2 py-0.5 text-xs font-medium rounded border-[0.5px] ${
                verified
                    ? 'bg-green-900/40 text-green-300 border-green-800/60 light:bg-green-100 light:text-green-800 light:border-green-300'
                    : 'bg-fg/5 text-fg/68 border-fg/15'
            }`}
        >
            {t(verified ? 'verifyEmail.verified' : 'verifyEmail.unverified')}
        </span>
    );
}
